import { configureMockStore } from './configureMockStore'
import { reduxLogger } from 'state/reduxLogger'

export const createMockStore = configureMockStore([reduxLogger])
